//============================================================================
// Name        : ErrorDialog.tsx
// Purpose     : Implement Warehouse error dialog
// Created     : 2019-07-01
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { css, jsx } from "@emotion/core";
import React from "react";
import { connect } from "react-redux";
import { IErrorDialogProps, ReceiveActions } from "./types";

const content = css({
    backgroundColor: "#ba4949",
    color: "white"
});

class ErrorDiag extends React.Component<IErrorDialogProps> {
    getClassName = () => {
        return this.props.show ? "modal show" : "modal fade";
    }

    onlyUnique(value, index, array) {
      return array.indexOf(value) === index;
    }


    getMessageLines = () => {
        const lines = this.props.message.split("\n").filter(this.onlyUnique);
        return lines.map( (l, key) => (<div key={key}>{l}</div>) );
    }

    render() {
        return (
            <div className={this.getClassName()} tabIndex={-1} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content" css={content}>
                        <div className="modal-header">
                            <button onClick={this.props.hideErrorDialog} type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">{this.props.title}</h1>
                        </div>
                        <div className="modal-body" css={{ textAlign: "center" }}>
                            {this.getMessageLines()}
                        </div>
                        <div className="modal-footer" css={{ padding: "15px" }}>
                            <button onClick={this.props.hideErrorDialog} className="man-btn">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    show: state.receiveOrders.showError
});

const mapDispatchToProps = dispatch => ({
    hideErrorDialog: () => dispatch({
        type: ReceiveActions.HideErrorDialog
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorDiag);
